import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

type CommissionPendingFilters = {
  company_id: number | string;
  start_date?: string; // 'YYYY-MM-DD' - Optional
  end_date?: string; // 'YYYY-MM-DD' - Optional
};

export async function getComisionesPendientes(
  filters: CommissionPendingFilters,
) {
  if (!filters) return false;

  const { company_id, start_date, end_date } = filters;

  if (!company_id) {
    throw new Error('company_id es obligatorio');
  }

  const params = new URLSearchParams();
  params.append('company_id', String(company_id));

  // Add dates only if provided
  if (start_date) {
    params.append('start_date', start_date);
  }
  if (end_date) {
    params.append('end_date', end_date);
  }

  const base = (API_URL ?? '').replace(/\/$/, '');

  const response = await axios.get(
    `${base}/payments/commission-payment/pending?${params.toString()}`,
  );

  return response.data?.doc?.data ?? response.data;
}

type PayCommissionPayload = {
  companyId: number;
  commissionIds: number[];
};

export async function payCommission(payload: PayCommissionPayload) {
  if (!payload?.companyId || !payload?.commissionIds?.length) {
    throw new Error('companyId y commissionIds son obligatorios');
  }

  const base = (API_URL ?? '').replace(/\/$/, '');

  const response = await axios.post(`${base}/payments/commission-payment/pay`, {
    companyId: payload.companyId,
    commissionIds: payload.commissionIds,
  });

  return response.data;
}

export async function getAllCommissions(filters?: {
  balance_filter?: string;
  start_date?: string;
  end_date?: string;
}) {
  const queryParams = new URLSearchParams();

  if (filters?.balance_filter)
    queryParams.append('balance_filter', filters.balance_filter);
  if (filters?.start_date) queryParams.append('start_date', filters.start_date);
  if (filters?.end_date) queryParams.append('end_date', filters.end_date);

  const response = await axios.get(
    `${API_URL}payments/commission-payment/balances?${queryParams.toString()}`,
  );
  const data = response.data?.doc?.data;
  return data;
}
